import React from 'react'

interface IProps {
    className?: string
}

const WizSpinner: React.FC<IProps> = ({className}) => {
    return (
        <div
            className={
                'w-[30px] h-[30px] rounded-full inline-block relative border-[5px] border-[#0AAF82_#0AAF82_transparent] box-border animate-spin '
            }></div>
    )
}

export default WizSpinner
